export default __webpack_public_path__ + "static/media/Time Management@3x.9b7ba279.png";